
import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import UiButtonMessage from "@/components/button/ui-button-message.vue";
import FormGroup from "@/components/form/FormGroupNew.vue";
import FormDatepicker from "@/components/form/FormDatepickerV2.vue";

interface NotesCollectionFiltersQuery {
    nameJobTitle: string;
    createdAt: string;
}

@Component({
    components: {
        FormGroup,
        UiButtonMessage,
        FormDatepicker
    },
})
export default class NotesCollectionFilters extends Vue {
    @Prop({ type: String, required: true }) readonly currentUserId!: string;
    @Prop({ type: String, required: true }) readonly parentInputClass!: string;
    @Prop({ type: Object, required: true }) readonly filters!: NotesCollectionFiltersQuery;

    nameJobTitle: string = "";
    createdAt: string = "";
    isTyping: boolean = false;
    typingTimer: any = null;

    get trimmedName(): string {
        return this.nameJobTitle.trim();
    }

    get propToWatch(): string {
        return JSON.stringify([
            this.trimmedName,
            this.createdAt
        ]);
    }    
    @Watch("filters", { immediate: true })
    updateFiltersValues(): void {
        // Only update nameJobTitle if it's different and not currently being edited by user
        if (this.nameJobTitle !== this.filters.nameJobTitle && !this.isTyping) {
            this.nameJobTitle = this.filters.nameJobTitle;
        }
        // Date input can be updated normally as it doesn't have the same issue
        this.createdAt = this.filters.createdAt;
    }    @Watch("propToWatch")
    handlePropToWatchChange(): void {
        // Set typing flag to prevent filters watch from overriding user input
        this.isTyping = true;
        
        // Clear any existing timer
        clearTimeout(this.typingTimer);
        
        // Set a timer to emit the changes after user stops typing
        this.typingTimer = setTimeout(() => {
            const dateFormat = "YYYY-MM-DD";
            this.$emit("filtersChanged", {
                nameJobTitle: this.trimmedName,
                createdAt: this.createdAt
                    ? this.$moment(this.createdAt).format(dateFormat)
                    : "",
            });
            
            // Reset typing flag after a short delay to prevent race conditions
            setTimeout(() => {
                this.isTyping = false;
            }, 200);
        }, 500); // 500ms debounce
    }

    handleReset(): void {
        this.$emit("resetFilters");
    }
}
